
































































import Vue from "vue";
import { Prop, Component } from "vue-property-decorator";

/**
 * Utils
 */
import classes from "@/config/wow/classes";
import * as externalLinks from "@/config/external-links";
import * as imageLinks from "@/config/image-links";
import roles from "@/config/wow/roles";


/**
 * Components
 */
import CharacterCategory from "@/components/_global/CharacterCategory.vue";
import CharacterLabel from "@/components/_global/CharacterLabel.vue";


/**
 * Group card component.
 */
@Component({
	components: {
		CharacterLabel,
		CharacterCategory
	}
})
export default class SimpleGroupCard extends Vue {
	/// Injections
	classes = classes;
	externalLinks = externalLinks;
	imageLinks = imageLinks;
	roles = roles;

	/// Properties

	// Identifier
	@Prop({default: ""})
	index!: string;

	@Prop()
	title!: string;
	
	@Prop()
	titleImageSrc!: string;

	@Prop()
	titleRightIcon!: string;

	@Prop()
	titleColor!: string;

	@Prop({default: () => []})
	data!: any[];

	@Prop({default: () => []})
	observedData!: any[];
	
	@Prop({type: Boolean})
	displayPlayerCount!: boolean;

	@Prop()
	colorPlayerCount!: (playerCount: number) => string;
	
	// Label properties
	@Prop({default: 2})
	labelSize!: number;

	@Prop()
	labelBackgroundColor!: (character: any) => string;
	
	@Prop()
	labelContent!: (character: any) => string;


	/// Attributes
	get playerCount() {
		return this.data.length;
	}

	/// Methods
	get organizedData(): any {
		return roles.reduce((o, key) => ({
			...o,
			[key.name]: this.sortData(this.data.filter(x => x.role === key.name).map(x => ({
				...x,
				isUsed: this.observedData.find((od) => {
					return od.id === x.id;
				}) != null
			})))
		}), {});
	}

	sortData(data: any[]) {
		return data.sort((a, b) => {
			return a.class - b.class || ((a.name < b.name) ? -1 : (a.name > b.name) ? 1 : 0);
		});
	}
}
